@if (user) {
  <div id="tabContent" class="tabContent">
    @if (workspaces) {
      <pp-grid [ppOptions]="{ bodyPadding: true }">
        <ng-container title> {{ 'site_plan' | ppTranslate }} </ng-container>
        <ng-container titleBar-right>
          <div class="siteSettings__button-container">
            @if (workspaces[workspaceId].siteImageRef) {
              <pp-site-settings-plan-delete-button
                (ppOnPlanDeleted)="processPlanUpdatedResponse($event)"
              ></pp-site-settings-plan-delete-button>
            }
            @if ((uploadedImage || workspaces[workspaceId].siteImageRef) && !uploadedPdf) {
              <pp-button
                ppStyle="secondary"
                ppSize="small"
                (ppAction)="downloadPlan()"
                >{{ 'download' | ppTranslate }}</pp-button
                >
              }
              @if (newSitePlan || uploadedPdf) {
                <pp-button
                  ppId="updateSitePlanBtn--cancel"
                  ppStyle="secondary"
                  ppSize="small"
                  (ppAction)="cancelNewSitePlan()"
                  >
                  {{ 'cancel' | ppTranslate }}
                </pp-button>
              }
              @if (!newSitePlan && !uploadedPdf) {
                <pp-button
                  [ppStyle]="newSitePlan ? 'secondary' : 'primary'"
                  ppSize="small"
                  >
                  <label class="settingsNewSite__upload-button" for="sitePlanUpload">
                    {{ (workspaces[workspaceId].siteImageRef ? 'update' : 'add') | ppTranslate }}
                    {{ 'site_plan' | ppTranslate }}
                  </label>
                  <pp-upload
                    id="sitePlanUpload--update"
                    [ppId]="'sitePlanUpload'"
                    (ppUpload)="setSitePlan($event)"
                    ppAccept=".jpg, .jpeg, .png, .bmp, .pdf"
                    >
                  </pp-upload>
                </pp-button>
              }
              <pp-site-plan-format (ppSelectFormat)="selectFormat($event)"></pp-site-plan-format>
              @if (newSitePlan || uploadedPdf || uploadedPdf) {
                <pp-button
                  ppId="updateSitePlanBtn--update"
                  [ppStyle]="newSitePlan || uploadedPdf ? 'primary' : 'secondary'"
                  ppSize="small"
                  [ppDisabled]="!(newSitePlan || uploadedPdf)"
                  [ppProcess]="processingSitePlanUpdate"
                  (ppAction)="updateSitePlan()"
                  >
                  {{ 'confirm' | ppTranslate }}
                </pp-button>
              }
            </div>
          </ng-container>
          <ng-container body>
            @if (!workspaces[workspaceId].siteImageRef && !uploadedImage && !uploadedPdf) {
              <div
                class="settingsSection__no-content"
                >
                {{ 'no_site_plan_found' | ppTranslate }}
              </div>
            }
            @if (workspaces[workspaceId].siteImageRef && !uploadedImage && !uploadedPdf) {
              <img
                #sitePlanImage
                ppImage
                class="siteSettingsPlan__site-plan"
                [ppSecureSrc]="'api/v1/images/' + planId + '/file/size/original'"
                (load)="updateImageSize('site')"
                />
            }
            @if (uploadedImage) {
              <img
                #uploadedPlanImage
                ppImage
                class="siteSettingsPlan__site-plan"
                [src]="uploadedImage"
                (load)="updateImageSize('upload')"
                />
            }
            @if (uploadedPdf) {
              <div>{{ 'pdf_preview_not_available' | ppTranslate }}</div>
            }
            @if (planWidth || planHeight) {
              <div class="settingsSection__plan-details">
                <p>{{ 'image_width' | ppTranslate }}: {{ planWidth }}px</p>
                <p>{{ 'image_height' | ppTranslate }}: {{ planHeight }}px</p>
              </div>
            }
          </ng-container>
        </pp-grid>
      }
    </div>
  }
